<template>
  <div class="app-shell">
    <ThreeBackground />
    <div class="page">
      <h1>Image scanner</h1>
      <p class="blurb">
        Pick a photo from your device. It runs a compact COCO-SSD model in your browser and draws boxes
        around things it thinks it sees (people, animals, vehicles, and other everyday objects).
        This model is built for speed and small size, not lab-grade accuracy — it can miss objects, merge
        nearby things, or label them wrong, especially in cluttered, dark, or unusual photos.
      </p>
      <ImageScanner />
    </div>
  </div>
</template>

<script>
import ImageScanner from './components/ImageScanner.vue';
import ThreeBackground from './components/ThreeBackground.vue';

export default {
  name: 'App',
  components: { ImageScanner, ThreeBackground },
};
</script>

<style>
html {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

body {
  margin: 0;
  background: #dde3ee;
}

@media (prefers-color-scheme: dark) {
  body {
    background: #04060d;
  }
}

.app-shell {
  position: relative;
  min-height: 100vh;
}

.page {
  position: relative;
  z-index: 1;
  max-width: 960px;
  margin: 1.5rem auto 2.5rem;
  padding: 1.25rem 1rem 2rem;
  background: rgba(252, 252, 252, 0.82);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 14px;
  box-shadow: 0 12px 48px rgba(30, 40, 60, 0.12);
}

@media (prefers-color-scheme: dark) {
  .page {
    background: rgba(18, 20, 28, 0.78);
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
  }
}

h1 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.75rem;
  color: #2c3e50;
}

.blurb {
  margin: 0 0 1.5rem;
  max-width: 42rem;
  line-height: 1.5;
  color: #555;
  font-size: 0.95rem;
}

@media (prefers-color-scheme: dark) {
  h1 {
    color: #e8e8e8;
  }

  .blurb {
    color: #b0b0b0;
  }
}
</style>
